import * as React from 'react';
import { Check, X } from 'lucide-react';

import { Button } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface InlineEditActionsProps {
  readonly isPending: boolean;
  /** Confirm is disabled when false — defaults to true (always confirmable). */
  readonly isValid?: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Confirm/cancel ghost icon-button pair shared by every drawer inline editor
 * (content fields, carrier). Mirrors PHA-270's Save/Cancel affordance, adapted to the
 * ticket's check/x icon-button design.
 */
export function InlineEditActions({
  isPending,
  isValid = true,
  onCancel,
  onConfirm,
}: InlineEditActionsProps): React.JSX.Element {
  return (
    <>
      <Button
        className="h-7 w-7 text-success"
        disabled={isPending || !isValid}
        onClick={(): void => onConfirm()}
        size="icon"
        type="button"
        variant="ghost"
      >
        <Check className="h-3.5 w-3.5" />
      </Button>
      <Button
        className="h-7 w-7 text-muted-foreground"
        disabled={isPending}
        onClick={onCancel}
        size="icon"
        type="button"
        variant="ghost"
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </>
  );
}
